import React, { lazy, Suspense } from 'react';
import Empirioapp from './lumio';
import PreviewPage from './interactive/PreviewPage';

const DragDropTestPage = lazy(() => import('./pages/DragDropTestPage'));
const InlineClozeTestPage = lazy(() => import('./pages/InlineClozeTestPage'));
const HotSpotTestPage = lazy(() => import('./pages/HotSpotTestPage'));
const MatchTypesTestPage = lazy(() => import('./pages/MatchTypesTestPage'));
const HotTextV2TestPage = lazy(() => import('./pages/HotTextV2TestPage'));
const ExamModeTestPage = lazy(() => import('./pages/ExamModeTestPage'));
const ImageMCQPracticePage = lazy(() => import('./pages/ImageMCQPracticePage'));
const Model3DViewerTestPage = lazy(() => import('./pages/Model3DViewerTestPage'));
const DnaHelixTestPage = lazy(() => import('./pages/DnaHelixTestPage'));

function App() {
  const params   = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

  // /test/drag-drop — path-based route (works on Railway because server catch-all serves index.html)
  if (pathname === '/test/drag-drop') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <DragDropTestPage />
      </Suspense>
    );
  }
  // /test/exam-mode — path-based route for ExamMode widget test page
  if (pathname === '/test/exam-mode') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <ExamModeTestPage />
      </Suspense>
    );
  }
  // /test/hot-text-v2 — path-based route for HotText V2 test page
  if (pathname === '/test/hot-text-v2') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <HotTextV2TestPage />
      </Suspense>
    );
  }
  // /test/match-types — path-based route for ExtractMatching + GapMatch test page
  if (pathname === '/test/match-types') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <MatchTypesTestPage />
      </Suspense>
    );
  }
  // /test/hot-spot — path-based route for HotSpot widget test page
  if (pathname === '/test/hot-spot') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <HotSpotTestPage />
      </Suspense>
    );
  }
  // /test/inline-cloze — path-based route for InlineCloze widget test page
  if (pathname === '/test/inline-cloze') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <InlineClozeTestPage />
      </Suspense>
    );
  }
  // /test/model-3d — path-based route for Model3DViewer widget test page
  if (pathname === '/test/model-3d') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <Model3DViewerTestPage />
      </Suspense>
    );
  }
  // /test/dna-helix — path-based route for DnaHelix widget test page
  if (pathname === '/test/dna-helix') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <DnaHelixTestPage />
      </Suspense>
    );
  }
  // /?preview=interactive — dev-only preview for interactive primitives
  if (params && params.get('preview') === 'interactive') {
    return <PreviewPage />;
  }
  // /practice/image-mcq — ImageMCQ widget showcase
  if (pathname === '/practice/image-mcq') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <ImageMCQPracticePage />
      </Suspense>
    );
  }
  // /?preview=drag-drop — legacy query-param alias (keep for backward compat)
  if (params && params.get('preview') === 'drag-drop') {
    return (
      <Suspense fallback={<div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>Loading…</div>}>
        <DragDropTestPage />
      </Suspense>
    );
  }
  return <Empirioapp />;
}

export default App;
